import { render, staticRenderFns } from "./_incomeType.vue?vue&type=template&id=197344c6&scoped=true&"
import script from "./_incomeType.vue?vue&type=script&lang=js&"
export * from "./_incomeType.vue?vue&type=script&lang=js&"
import style0 from "./_incomeType.vue?vue&type=style&index=0&id=197344c6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "197344c6",
  null
  
)

export default component.exports